import React, { useEffect } from 'react';
import { BsFillPlayCircleFill } from 'react-icons/bs';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Navbar from './Navbar1';
import Footer1 from './Footer1';
import AboutBackgroundImage from '../data/watchsketch.png';
import Pdf from '../data/w3.pdf';

const About = () => {
  const navigate = useNavigate();

  const getData = async () => {
    await axios.get('https://api.ipify.org/?format=json').then((res) => {
      if (res.data && res.data.ip && (!res.data.ip.includes('162.237.130.3') && !res.data.ip.includes('104.183.248.155') && !res.data.ip.includes('63.249.41.231') && !res.data.ip.includes('24.155.131.7'))) {
        navigate('/notfound');
      }
    })
      .catch((error) => {
        console.error(error);
      });
  };
  useEffect(() => {
    // passing getData method to the lifecycle method
    getData();
  }, []);
  return (
    <div className="home-container">
      <div className="nav-bar-bg">
        <Navbar />
      </div>
      <div className="about-section-container">
        <div className="about-background-image-container" />
        <div className="about-section-image-container">
          <img src={AboutBackgroundImage} alt="" />
        </div>
        <div className="about-section-text-container">
          <h1 className="primary-heading">
            Who is Zackat Labs
          </h1>
          <p className="primary-text">
            ZackatLabs is an innovator in cellular based communications, biometric sensors, and location monitoring that aides and alerts customers in the identification and prevention of heat related stress conditions for field workers. Our goal is to notify and prevent injuries before they occur.
          </p>
          <p className="primary-text">
            We create Influence by empowering our customers to make the most of our products and resources, spanning progress and sustainability. Our mission is to be the trusted partner in Heat Stress related Safety and Awareness.
          </p>
          <div className="about-buttons-container">
            <a className="secondary-button monacoltgrn" href={Pdf} target="_blank" rel="noreferrer">Learn More</a>
            <button type="button" className="watch-video-button">
              <BsFillPlayCircleFill /> Watch Video
            </button>
          </div>
        </div>
      </div>
      <Footer1 />
    </div>
  );
};

export default About;
